import React, { useEffect,useState } from 'react'
import axios from 'axios'
import "./PostsRow.css"
import { imgUrls, options } from '../Constants/Content'

function PostsRow(props) {
  const [movies,setMovies]=useState([])
  const [genre,setGenre]=useState("")
  useEffect(()=>{
    axios.get(props.url,options).then((res)=>{
      
      setMovies(res.data.results)
      setGenre(props.title)
    })
  })
  return (
    <div className='posterRow' id={genre}>
        <h2>{genre}</h2>
        <div className='posters'>
          {movies.map((obj)=>
            <img className='poster' src={`${imgUrls+obj.poster_path}`} alt="poster"/>
          )}

        </div>

    </div>
  )
}

export default PostsRow